import React from "react";
import _ from "lodash";
import { Card, CardContent, Typography } from "@material-ui/core";
import { gql } from "@apollo/client";
import styled from "styled-components";
import LabeledValue from "components/presentation/LabeledValue";
import { H4 } from "components/presentation/headers";
import { formatDateTime } from "helpers/date";
import { formatPriceRange } from "helpers/price";
import { getPrefectureCode, formatLocationPath } from "helpers/location";
import { paths } from "Routes";
import ExternalLink from "./ExternalLink";
import InternalLink from "./InternalLink";

const Container = styled(Card)`
  margin: 8px 0 16px;
`;

const EventGroupListItem = ({ eventGroup, locationFilter }) => {
  const {
    name,
    notes,
    website,
    ticketPriceLowest,
    ticketPriceHighest,
    companies,
    works,
    items,
  } = eventGroup;

  return (
    <Container>
      <CardContent>
        <H4>{name}</H4>
        <LabeledValue label="主催者など">
          {companies.map((company) => (
            <Typography key={company.id}>
              <InternalLink to={paths.company.replace(":id", company.id)}>
                {company.nameJa}
              </InternalLink>
            </Typography>
          ))}
        </LabeledValue>
        <LabeledValue label="上演作品">
          {works.map((work) => (
            <Typography key={work.id}>
              <InternalLink to={paths.work.replace(":id", work.id)}>
                {work.titleJa}
              </InternalLink>{" "}
              ({work.composer.nameJa})
            </Typography>
          ))}
        </LabeledValue>
        <LabeledValue label="上演形式など">
          <Typography>{notes}</Typography>
        </LabeledValue>
        <LabeledValue label="ウェブサイト">
          <Typography>
            <ExternalLink href={website} />
          </Typography>
        </LabeledValue>
        <LabeledValue label="チケット価格">
          <Typography>
            {formatPriceRange(ticketPriceLowest, ticketPriceHighest) || "-"}
          </Typography>
        </LabeledValue>
        <LabeledValue label="日程・会場">
          {filterByVenue(sortByDateTime(items), locationFilter).map((item) => (
            <EventItemField key={item.id} item={item} />
          ))}
        </LabeledValue>
      </CardContent>
    </Container>
  );
};

const EventItemField = ({ item }) => {
  const { dateTime, venue } = item;

  const makeVenueLink = ({ website, nameJa }) => {
    if (!website) return nameJa;
    return <ExternalLink href={website}>{nameJa}</ExternalLink>;
  };

  return (
    <Typography>
      {formatDateTime(dateTime)} {makeVenueLink(venue)} (
      {formatLocationPath(venue.location)})
    </Typography>
  );
};

function filterByVenue(items, locationFilter) {
  if (locationFilter == null || locationFilter.length === 0) return items;

  return items.filter((item) =>
    locationFilter.includes(getPrefectureCode(item.venue.location))
  );
}

function sortByDateTime(items) {
  return _.sortBy(items, "dateTime");
}

EventGroupListItem.fragments = {
  eventGroup: gql`
    fragment EventGroupListItemEventGroup on EventGroup {
      id
      name
      notes
      website
      ticketPriceLowest
      ticketPriceHighest
      companies {
        id
        nameJa
      }
      works {
        id
        titleJa
        composer {
          id
          nameJa
        }
      }
      items {
        id
        dateTime
        venue {
          id
          nameJa
          location
          website
        }
      }
    }
  `,
};

export default EventGroupListItem;
